import { GlobalMessages, TranslationGlobalMessages } from "@languages/interfaces/globalMessages";

export const messages: TranslationGlobalMessages = {
  [GlobalMessages.filtersText]: "Filtros",
  [GlobalMessages.activeText]: "Ativo",
  [GlobalMessages.inactiveText]: "Inativo",
  [GlobalMessages.saveText]: "Salvar",
  [GlobalMessages.columnActions]: "Ações",
  [GlobalMessages.buttonAdd]: "Adicionar novo",
  [GlobalMessages.buttonDelete]: "Excluir",
  [GlobalMessages.buttonRefresh]: "Atualizar",
  [GlobalMessages.buttonCancel]: "Cancelar",
  [GlobalMessages.buttonConfirm]: "Confirmar",
  [GlobalMessages.entityUser]: "Usuário",
  [GlobalMessages.yesText]: "Sim",
  [GlobalMessages.noText]: "Não",
  [GlobalMessages.resetPasswordText]: "Redefinir senha",
  [GlobalMessages.logout]: "Sair",
  [GlobalMessages.editUser]: "Editar usuário",
  [GlobalMessages.invalidFormInputs]: "Preencha todas as informações obrigatórias da aba atual",
  [GlobalMessages.toastWarning]: "Aviso",
  [GlobalMessages.errorText]: "Erro",
  [GlobalMessages.warningTitleText]: "Aviso",
  [GlobalMessages.selectAllText]: "Selecionar todos",
  [GlobalMessages.removeAllText]: "Remover todos",
  [GlobalMessages.noRecordsFoundText]: "Nenhum registro encontrado",
  [GlobalMessages.loading]: "Carregando...",
  [GlobalMessages.accessDenied]: "Acesso negado",
  [GlobalMessages.insufficientPermissions]: "Você não tem permissão para executar esta ação"
};
